import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { Container, Typography, Button, Box, Paper, List, ListItem } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import KeywordsIcon from "@mui/icons-material/Label";
import styles from "./VerbetesConteudo.module.css";
import DescriptionIcon from '@mui/icons-material/Description';
import EventIcon from '@mui/icons-material/Event';
import LocationOnIcon from '@mui/icons-material/LocationOn';


const apiUrl = process.env.REACT_APP_API_URL;

const fetchVerbete = async (id) => {
  const res = await fetch(`${apiUrl}/verbetes/${id}`);
  if (!res.ok) throw new Error('Erro ao carregar o verbete');
  return res.json();
};

const VerbetesConteudo = ({ showLink = true }) => {
  const { id } = useParams();
  const [verbete, setVerbete] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getVerbete = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const data = await fetchVerbete(id);
        setVerbete(data);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };

    getVerbete();
  }, [id]);

  if (isLoading) return <Typography variant="h6">Carregando...</Typography>;
  if (error) return <Typography color="error">Erro ao carregar os dados: {error}</Typography>;

  return (
    <div className="artigo-background">
 
      <Container maxWidth="lg">
        <Paper elevation={3} sx={{ padding: 4, mt: 4, borderRadius: 2 }}>
          {/* Cabeçalho com título e imagem */}
         <Typography
                     variant="h2"
                     align="center"
                     gutterBottom
                     style={{
                       fontFamily: "'Lato', serif",
                       color: "#800020",
                       textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                       borderBottom: "4px solid #d4af37",
                       paddingBottom: "10px",
                       textTransform: "uppercase",
                       animation: "glow 2s infinite alternate",
                       marginTop: "7%"  // Aqui é onde você define o espaço superior
                     }}
                   >
            {verbete.titulo}
          </Typography>

          <Box display="flex" justifyContent="center" my={3}>
          <Typography
  variant="h6"
  sx={{
    textAlign: "center",
    color: "#444",
    fontFamily: "'Lato', sans-serif",
    fontWeight: 500,
    letterSpacing: "0.5px",
    padding: "8px 0",
    borderBottom: "2px solid rgba(0, 0, 0, 0.1)",
    display: "inline-block",
  }}
>
  {verbete.autor}
</Typography>

              
          </Box>
          <Box display="flex" justifyContent="space-between" alignItems="center" mt={4}>
            <Box>
              <Button
                variant="contained"
                color="primary"
                startIcon={<DownloadIcon />}
                href={verbete.linkpdfverbete}
                target="_blank"
                sx={{
                  fontWeight: 'bold',
                  textTransform: 'none',
                  borderRadius: '25px',
                  backgroundColor: '#FFEB3B', // Cor de fundo amarela
                  padding: '12px 24px', // Aumenta o tamanho do botão (altura e largura)
                  fontSize: '18px', // Aumenta o tamanho da fonte
                  '&:hover': {
                    backgroundColor: '#800020', // Cor de fundo ao passar o mouse
                    transform: 'scale(1.1)', // Aumenta mais o botão ao passar o mouse
                    transition: 'transform 0.3s ease, background-color 0.3s ease', // Efeito suave
                  },
                }}
              >
                Baixar PDF
              </Button>
            </Box>

            {showLink && (
              <Box>
                <Link to={`/DocumentoDoVerbete/${verbete._id}`} style={{ textDecoration: 'none' }}>
                  <Button variant="outlined" startIcon={<LibraryBooksIcon />}>
                    Visualizar Documento
                  </Button>
                </Link>
              </Box>
            )}
          </Box>


          <hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />

          <Typography variant="body1" component="div" sx={{ lineHeight: 1.8, textAlign: 'justify' }} dangerouslySetInnerHTML={{ __html: verbete.textoPortugues }} />

          <Typography variant="caption" display="block" sx={{ mt: 2, fontStyle: 'italic', textAlign: 'right', color: 'gray' }}>
            Publicado em: {new Date(verbete.dataCriacao).toLocaleDateString('pt-BR')}
          </Typography>





          <hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />
          <Box
  display="flex"
  justifyContent="center"
  alignItems="center"
  p={4}
  sx={{
    background: "linear-gradient(135deg, #FED13E 30%, #FFD700 100%)", // Efeito de degradê dourado
    borderRadius: "20px",
    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)", // Sombra mais profunda para realce
    width: "100%",
    maxWidth: "850px",
    margin: "50px auto",
    textAlign: "center",
    border: "3px solid #b8860b", // Dourado queimado para sofisticação
    padding: "20px",
  }}
>
  <Typography
    variant="h4"
    sx={{
      fontFamily: "'Lato', serif",
      color: "#5A0000", // Um bordô mais escuro para contraste
      textShadow: "3px 3px 6px rgba(0, 0, 0, 0.3)",
      borderBottom: "4px solid #b8860b",
      paddingBottom: "12px",
      textTransform: "uppercase",
      fontWeight: "bold",
      letterSpacing: "1.2px",
      maxWidth: "90%",
      animation: "glow 2s infinite alternate",
    }}
  >
    Versão em Espanhol
  </Typography>
</Box>



          <Box display="flex" flexDirection="column" alignItems="center" my={3}>
          <Typography
               variant="h4"
               align="center"
               gutterBottom
               style={{
                 fontFamily: "'Lato', serif",
                 color: "#800020",
                 textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                 borderBottom: "4px solid #d4af37",
                 paddingBottom: "10px",
                 textTransform: "uppercase",
                 animation: "glow 2s infinite alternate",
                 marginTop: "7%"  // Aqui é onde você define o espaço superior
              }}
            >
              {verbete.titulo}
            </Typography>
            <Typography
  variant="h6"
  sx={{
    textAlign: "center",
    color: "#444",
    fontFamily: "'Lato', sans-serif",
    fontWeight: 500,
    letterSpacing: "0.5px",
    padding: "8px 0",
    borderBottom: "2px solid rgba(0, 0, 0, 0.1)",
    display: "inline-block",
  }}
>
              {verbete.autor}
            </Typography>
          </Box>


          <Typography variant="body1" component="div" sx={{ lineHeight: 1.8, textAlign: 'justify' }} dangerouslySetInnerHTML={{ __html: verbete.textoEspanhol }} />

          <Box className={styles.authorInfo} sx={{ my: 3, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <Typography variant="h6"><b>{verbete.autor}</b></Typography>
            <Typography variant="h6"><b>{verbete.instituicaoautor}</b></Typography>
          </Box>


          <Box
  display="flex"
  justifyContent="center"
  alignItems="center"
  p={4}
  sx={{
    backgroundColor: "#FED13E", // Amarelo suave para um destaque agradável
    borderRadius: "16px",
    boxShadow: "0 6px 12px rgba(0, 0, 0, 0.15)", // Sombra mais suave e profunda
    width: "100%",
    maxWidth: "800px", // Limita a largura para melhor estética
    margin: "40px auto", // Centraliza e dá mais respiro
    textAlign: "center",
    border: "2px solid #d4af37", // Borda sutil para sofisticação
  }}
>
            <KeywordsIcon />
            <Typography variant="body1"><b> Palavras-chave:</b> {verbete.palavrachave}</Typography>
          </Box>

          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            p={3}
            sx={{
              backgroundColor: '#FED13E', // Amarelo claro para o fundo do Box
              borderRadius: '12px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Sombra suave para profundidade
              width: '100%', // Ocupar toda a largura disponível
              margin: '30px 0',
            }}
          >
            {/* Título com ícone */}
            <Typography variant="h5" sx={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>

            <Typography
    variant="h4"
    sx={{
      fontFamily: "'Lato', serif",
      color: "#5A0000", // Um bordô mais escuro para contraste
      textShadow: "3px 3px 6px rgba(0, 0, 0, 0.3)",
      borderBottom: "4px solid #b8860b",
      paddingBottom: "12px",
      textTransform: "uppercase",
      fontWeight: "bold",
      letterSpacing: "1.2px",
      
      animation: "glow 2s infinite alternate",
    }}
  ><BookmarkIcon /> Edições Modernas</Typography>

            </Typography>

            {/* Conteúdo com fundo cinza */}
            <Box sx={{ backgroundColor: '#f5f5f5', padding: '16px', borderRadius: '8px', width: '100%' }}>
              <Typography dangerouslySetInnerHTML={{ __html: verbete.edicoes }} />
            </Box>
          </Box>





          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            p={3}
            sx={{
              backgroundColor: '#FED13E', // Amarelo claro para o fundo do Box
              borderRadius: '12px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Sombra suave para profundidade
              width: '100%', // Ocupar toda a largura disponível
              margin: '30px 0',
            }}
          >
            {/* Título com ícone */}
            <Typography
    variant="h4"
    sx={{
      fontFamily: "'Lato', serif",
      color: "#5A0000", // Um bordô mais escuro para contraste
      textShadow: "3px 3px 6px rgba(0, 0, 0, 0.3)",
      borderBottom: "4px solid #b8860b",
      paddingBottom: "12px",
      textTransform: "uppercase",
      fontWeight: "bold",
      letterSpacing: "1.2px",
      
      animation: "glow 2s infinite alternate",
    }}
  >
              <LibraryBooksIcon sx={{ marginRight: '8px' }} />
              Trecho traduzido e modernizado
            </Typography>

            {/* Conteúdo com fundo cinza */}
            <Box sx={{ backgroundColor: '#f5f5f5', padding: '16px', borderRadius: '8px', width: '100%' }}>
              <Typography dangerouslySetInnerHTML={{ __html: verbete.trechoTraduzidoModernizado }} />
              <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: 2 }}>

              </Typography>
            </Box>
          </Box>

          <Box className={styles.details} sx={{ my: 3 }}>
          <Box
  display="flex"
  justifyContent="center"
  alignItems="center"
  p={4}
  sx={{
    backgroundColor: "#FED13E", // Amarelo suave para um destaque agradável
    borderRadius: "16px",
    boxShadow: "0 6px 12px rgba(0, 0, 0, 0.15)", // Sombra mais suave e profunda
    width: "100%",
    maxWidth: "800px", // Limita a largura para melhor estética
    margin: "40px auto", // Centraliza e dá mais respiro
    textAlign: "center",
    border: "2px solid #d4af37", // Borda sutil para sofisticação
  }}
>
<Typography
    variant="h4"
    sx={{
      fontFamily: "'Lato', serif",
      color: "#5A0000", // Um bordô mais escuro para contraste
      textShadow: "3px 3px 6px rgba(0, 0, 0, 0.3)",
      borderBottom: "4px solid #b8860b",
      paddingBottom: "12px",
      textTransform: "uppercase",
      fontWeight: "bold",
      letterSpacing: "1.2px",
      
      animation: "glow 2s infinite alternate",
    }}
  >
                Detalhes do Documento
              </Typography>
            </Box>
            <List sx={{ listStyleType: 'none', paddingLeft: 0 }}>
              <ListItem sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '10px 0',
                borderBottom: '1px solid #ddd', // Separador sutil entre os itens
                '&:hover': {
                  backgroundColor: '#f5f5f5', // Fundo ao passar o mouse
                },
              }}>
                <LibraryBooksIcon sx={{ marginRight: 2, fontSize: '1.5rem', color: '#FFEB3B' }} />
                <Typography variant="body1" sx={{ fontSize: '1rem', color: '#333' }}>
                  <b>Autor do documento:</b> {verbete.autorDocumento}
                </Typography>
              </ListItem>

              <ListItem sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '10px 0',
                borderBottom: '1px solid #ddd',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
              }}>
                <DescriptionIcon sx={{ marginRight: 2, fontSize: '1.5rem', color: '#FFEB3B' }} />
                <Typography variant="body1" sx={{ fontSize: '1rem', color: '#333' }}>
                  <b>Nome do documento:<Typography component="span" sx={{ fontStyle: "italic" }}> {verbete.nomeDocumento}</Typography></b>  
                </Typography>
              </ListItem>

              <ListItem sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '10px 0',
                borderBottom: '1px solid #ddd',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
              }}>
                <EventIcon sx={{ marginRight: 2, fontSize: '1.5rem', color: '#FFEB3B' }} />
                <Typography variant="body1" sx={{ fontSize: '1rem', color: '#333' }}>
                  <b>Data da composição:</b> {new Date(verbete.dataComposicao).toLocaleDateString()}
                </Typography>
              </ListItem>

              <ListItem sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '10px 0',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
              }}>
                <LocationOnIcon sx={{ marginRight: 2, fontSize: '1.5rem', color: '#FFEB3B' }} />
                <Typography variant="body1" sx={{ fontSize: '1rem', color: '#333' }}>
                  <b>Lugar de composição ou impressão:</b> {verbete.lugarComposicaoOuImpressao}
                </Typography>
              </ListItem>
           

            <ListItem sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '10px 0',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
              }}>
                <DescriptionIcon sx={{ marginRight: 2, fontSize: '1.5rem', color: '#FFEB3B' }} />
                <Typography variant="body1" sx={{ fontSize: '1rem', color: '#333' }}>
                  <b>Imagem:</b> {verbete.nomeImagemDocumento}
                </Typography>
              </ListItem>
            </List>

          </Box>


           

          <Box className={styles.imageContainer} sx={{ my: 4 }}>
            <img
              src={verbete.imagemDocumento}
              alt="Imagem do Verbete"
              style={{
                maxWidth: '100%', // Garante que a imagem ocupe 100% da largura disponível
                borderRadius: '12px', // Bordas arredondadas para um visual mais suave
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Sombra suave para dar profundidade
                objectFit: 'cover', // Garante que a imagem se ajuste bem ao tamanho do container sem deformar
              }}
            />
          </Box>

        </Paper>
      </Container>
    </div>
  );
};

export default VerbetesConteudo;
